import {
  Box,
  HStack,
  Textarea,
  FormControl,
  Text,
  Input,
  FormLabel,
  Select,
  InputGroup,
  Button,
  Flex,
  FormErrorMessage,
  useToast,
  InputLeftElement,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { MdMailOutline } from "react-icons/md";
import { ITrainerBio } from "../../models/trainerbio.model";
import trainerbioService from "../../services/trainer/trainerbio.service";
import trainerRegistration from "../../services/trainer/trainerRegistration";
import Loading from "../common/Loading";
import { BreadCrumbs } from "../common/BreadCrumb";
import { transcode } from "buffer";

const BasicDetailsTr = ({ nextPage, ...rest }: { nextPage: any }) => {
  const mountedRef = useRef(true);
  const courseFormatRef = useRef<HTMLSelectElement>(null);
  const [gender, setGender] = useState<any[]>([]);
  const [nationality, setNationality] = useState<any[]>([]);
  const [state, setState] = useState<any[]>([]);
  const [trainer, setTrainer] = useState<ITrainerBio>();
  const [loading, setLoading] = useState(true);

  const isMobile = useBreakpointValue({ base: true, md: true, lg: false });

  const toast = useToast();

  useEffect(() => {
    trainerRegistration.getNationality().then((res) => {
      setNationality(res.data.data);
    });
    trainerbioService.getTrainerBio().then((res) => {
      setTrainer(res.data);
      if (res.data.bio !== null && res.data.bio.nationality !== null) {
        const getState = (nationality_id: any) => {
          trainerRegistration.getState(nationality_id).then((res) => {
            setState(res.data.data);
          });
        };

        getState(res.data.bio.nationality);
      }
      setLoading(false);
      setRegisteredTrainer();
    });
    const maingender = [
      {
        id: "1",
        title: "Male",
      },
      {
        id: "2",
        title: "Female",
      },
    ];
    setGender(maingender);
  }, [trainer?.id]);

  // const getLga = (state_id: number) => {
  //   trainerRegistration.getLga(state_id).then((res) => {
  //       c
  //         });
  // };

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      const regex: any = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
      if (!values.firstName) {
        errors.firstName = "First Name is required";
      }
      if (!values.lastName) {
        errors.lastName = "Last Name is required";
      }
      // if (!values.otherName) {
      //   errors.otherName = "Other Name is required";
      // }
      if (!values.stateOfResidence) {
        errors.stateOfResidence = "State of residence is required";
      }
      if (!values.emailAddress) {
        errors.emailAddress = "Email Address is required";
      }
      if (!regex.test(values.emailAddress)) {
        errors.emailAddress = "Please enter a valid email address";
      }
      if (!values.phoneNumber) {
        errors.phoneNumber = "Phone Number is required";
      } else if (values.phoneNumber.toString().length !== 11) {
        console.log(values.phoneNumber.length, "Invalid phone number length");
        errors.phoneNumber = "Phone number must be exactly 11 digits";
      }

      if (!values.dob) {
        errors.dob = "Date of Birth is required";
      }
      if (new Date().getFullYear() - new Date(values.dob).getFullYear() < 0) {
        errors.dob = "Please select valid date";
      } else if (
        new Date().getFullYear() - new Date(values.dob).getFullYear() <
        15
      ) {
        errors.dob = "Minimum age should be 15years";
      }
      if (!values.gender) {
        errors.gender = "Gender is required";
      }
      if (!values.nationality) {
        errors.nationality = "Nationality is required";
      }
      if (!values.stateOfOrigin) {
        errors.stateOfOrigin = "State of Origin is required";
      }

      return errors;
    },
    initialValues: {
      firstName: "",
      lastName: "",
      otherName: "",
      stateOfResidence: "",
      emailAddress: "",
      phoneNumber: "",
      dob: "",
      gender: "",
      nationality: "",
      stateOfOrigin: "",
    },

    onSubmit: async (values) => {
      let basicDetails = {};
      basicDetails = {
        firstname: values.firstName,
        lastname: values.lastName,
        email: values.emailAddress,
        phone: values.phoneNumber.toString(),
        dob: values.dob,
        gender: values.gender,
        nationality: values.nationality,
        stateofresidence: values.stateOfResidence,
        stateoforigin: values.stateOfOrigin,
      };

      if (values.otherName?.length > 1) {
        basicDetails = {
          ...basicDetails,
          othername: values.otherName,
        };
      }

      try {
        const basicResponse = await trainerRegistration.updateUserBio(
          basicDetails
        );
        if (basicResponse) {
          nextPage();
          toast({
            title: "Registration",
            description: "Basic Details successful",
            status: "success",
          });
        } else {
          toast({
            title: "Registration",
            description: `${basicResponse.message}`,
            status: "success",
          });
        }
      } catch (error: any) {
        toast({
          title: "Registration",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    },
  });

  const setRegisteredTrainer = () => {
    console.log(trainer, "see trainer");
    if (trainer) {
      formik.setValues({
        firstName: trainer?.name?.split(" ")[0] || trainer?.bio?.firstname,
        lastName: trainer?.name?.split(" ")[1] || trainer?.bio?.lastname,
        otherName: trainer.bio ? trainer?.bio.othername : " ",
        stateOfResidence: trainer.bio
          ? trainer.bio.stateofresidence.id.toString()
          : " ",
        emailAddress: trainer.email,
        phoneNumber: trainer.phone,
        dob: trainer?.dob || trainer?.bio.dob,
        gender: trainer.gender || trainer.bio.gender,
        nationality: trainer.bio ? trainer.bio.nationality : " ",
        stateOfOrigin: trainer.bio
          ? trainer.bio.stateoforigin.id.toString()
          : " ",
      });
    }
  };

  const getState = (nationality_id: any) => {
    trainerRegistration.getState(nationality_id).then((res) => {
      setState(res.data.data);
    });
  };

  useEffect(() => {
    if (formik.values.nationality) {
      getState(formik.values.nationality);
    }
  }, [formik.values.nationality]);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box mb="50px" width={{ md: "auto", sm: "100%", base: "100%" }}>
          {/* {isMobile && (
            <Box width={"100%"} marginBottom={"2rem"}>
              <BreadCrumbs
                breadCrumbItems={breadcrumbItems}
                breadCrumbActiveItem="Basic Details"
              />
            </Box>
          )} */}

          <Flex justifyContent="center" mb="35px">
            <Text mx="auto" fontSize="32px" fontWeight="800">
              Basic Details
            </Text>
          </Flex>
          <Text mb="35px" color="#9E9E9E" fontSize="14px">
            All fields in{" "}
            <Text as="span" color="red">
              (*){" "}
            </Text>
            are required
          </Text>
          <form onSubmit={formik.handleSubmit}>
            <Flex
              mt={6}
              mb="25px"
              gap={{ lg: "2.2rem", md: "2rem", sm: "1rem", base: "1rem" }}
              flexDirection={{
                lg: "row",
                md: "row",
                sm: "column",
                base: "column",
              }}
            >
              <FormControl
                isInvalid={
                  formik.errors.firstName && formik.touched.firstName
                    ? true
                    : false
                }
                width={{ lg: "50%", md: "50%", sm: "100%", base: "100%" }}
              >
                <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                  First Name
                  <Text as="span" color="red">
                    {" "}
                    *{" "}
                  </Text>
                </FormLabel>
                <Input
                  bg="inputText.500"
                  placeholder="Enter Name"
                  value={formik.values.firstName}
                  name="firstName"
                  onChange={formik.handleChange}
                  fontSize={12}
                  height={"2.5rem"}
                />
                <FormErrorMessage fontSize={12}>
                  {formik.errors.firstName}
                </FormErrorMessage>
              </FormControl>
              <FormControl
                isInvalid={
                  formik.errors.lastName && formik.touched.lastName
                    ? true
                    : false
                }
                width={{ lg: "50%", md: "50%", sm: "100%", base: "100%" }}
              >
                <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                  Last Name{" "}
                  <Text as="span" color="red">
                    {" "}
                    *{" "}
                  </Text>
                </FormLabel>
                <Input
                  bg="inputText.500"
                  placeholder="Enter last Name"
                  value={formik.values.lastName}
                  name="lastName"
                  onChange={formik.handleChange}
                  fontSize={12}
                  height={"2.5rem"}
                />
                <FormErrorMessage fontSize={12}>
                  {formik.errors.lastName}
                </FormErrorMessage>
              </FormControl>
            </Flex>
            <Flex
              mb="25px"
              gap={{ lg: "2.2rem", md: "2rem", sm: "1rem", base: "1rem" }}
              flexDirection={{
                lg: "row",
                md: "row",
                sm: "column",
                base: "column",
              }}
            >
              <FormControl
                isInvalid={
                  formik.errors.otherName && formik.touched.otherName
                    ? true
                    : false
                }
                width={{ lg: "50%", md: "50%", sm: "100%", base: "100%" }}
              >
                <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                  Other Name
                </FormLabel>
                <Input
                  bg="inputText.500"
                  placeholder="Enter other name"
                  value={formik.values.otherName}
                  name="otherName"
                  onChange={formik.handleChange}
                  fontSize={12}
                  height={"2.5rem"}
                />
                <FormErrorMessage fontSize={12}>
                  {formik.errors.otherName}
                </FormErrorMessage>
              </FormControl>
              <FormControl
                isInvalid={
                  formik.errors.nationality && formik.touched.nationality
                    ? true
                    : false
                }
                width={{ lg: "50%", md: "50%", sm: "100%", base: "100%" }}
              >
                <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                  Nationality{" "}
                  <Text as="span" color="red">
                    {" "}
                    *{" "}
                  </Text>
                </FormLabel>
                <Select
                  variant="outline"
                  bg="inputText.500"
                  size="sm"
                  placeholder="Nationality"
                  value={formik.values.nationality}
                  name="nationality"
                  onChange={formik.handleChange}
                  fontSize={12}
                  color="brand.subtitle"
                  height={"2.5rem"}
                >
                  {nationality.map((each) => (
                    <option key={each.id} value={each.id}>
                      {" "}
                      {each.name}{" "}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage fontSize={12}>
                  {formik.errors.nationality}
                </FormErrorMessage>
              </FormControl>
            </Flex>
            <Flex
              mb="25px"
              gap={{ lg: "2.2rem", md: "2rem", sm: "1rem", base: "1rem" }}
              flexDirection={{
                lg: "row",
                md: "row",
                sm: "column",
                base: "column",
              }}
            >
              <FormControl
                isInvalid={
                  formik.errors.stateOfResidence &&
                  formik.touched.stateOfResidence
                    ? true
                    : false
                }
                width={{ lg: "50%", md: "50%", sm: "100%", base: "100%" }}
              >
                <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                  State of Residence{" "}
                  <Text as="span" color="red">
                    {" "}
                    *{" "}
                  </Text>
                </FormLabel>
                <Select
                  variant="outline"
                  bg="inputText.500"
                  size="sm"
                  placeholder="State"
                  value={formik.values.stateOfResidence}
                  name="stateOfResidence"
                  onChange={formik.handleChange}
                  fontSize={12}
                  color="brand.subtitle"
                  height={"2.5rem"}
                >
                  {state.map((each) => (
                    <option key={each.id} value={each.id}>
                      {" "}
                      {each.name}{" "}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage fontSize={12}>
                  {formik.errors.stateOfResidence}
                </FormErrorMessage>
              </FormControl>

              <FormControl
                isInvalid={
                  formik.errors.stateOfOrigin && formik.touched.stateOfOrigin
                    ? true
                    : false
                }
                width={{ lg: "50%", md: "50%", sm: "100%", base: "100%" }}
              >
                <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                  State of Origin{" "}
                  <Text as="span" color="red">
                    {" "}
                    *{" "}
                  </Text>
                </FormLabel>
                <Select
                  variant="outline"
                  bg="inputText.500"
                  size="sm"
                  placeholder="State"
                  value={formik.values.stateOfOrigin}
                  name="stateOfOrigin"
                  onChange={formik.handleChange}
                  fontSize={12}
                  color="brand.subtitle"
                  height={"2.5rem"}
                >
                  {state.map((each) => (
                    <option key={each.id} value={each.id}>
                      {" "}
                      {each.name}{" "}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage fontSize={12}>
                  {formik.errors.stateOfOrigin}
                </FormErrorMessage>
              </FormControl>
            </Flex>

            <Flex
              mb="25px"
              gap={{ lg: "2.2rem", md: "2rem", sm: "1rem", base: "1rem" }}
              flexDirection={{
                lg: "row",
                md: "row",
                sm: "column",
                base: "column",
              }}
            >
              <FormControl
                isInvalid={
                  formik.errors.phoneNumber && formik.touched.phoneNumber
                    ? true
                    : false
                }
                width={{ lg: "50%", md: "50%", sm: "100%", base: "100%" }}
              >
                <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                  Phone Number{" "}
                  <Text as="span" color="red">
                    {" "}
                    *{" "}
                  </Text>
                </FormLabel>
                <Input
                  type="tel"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="080*******"
                  onChange={formik.handleChange}
                  fontSize={13}
                  value={formik.values.phoneNumber}
                  height={"2.5rem"}
                />

                <FormErrorMessage fontSize={12}>
                  {formik.errors.phoneNumber}
                </FormErrorMessage>
              </FormControl>
              <FormControl
                // mb="25px"
                isInvalid={
                  formik.errors.emailAddress && formik.touched.emailAddress
                    ? true
                    : false
                }
                width={{ lg: "50%", md: "50%", sm: "100%", base: "100%" }}
              >
                <FormLabel color="brand.subtitle" fontSize={13}>
                  Email Address{" "}
                  <Text as="span" color="red">
                    {" "}
                    *{" "}
                  </Text>
                </FormLabel>
                <InputGroup>
                  <InputLeftElement
                    color="brand.subtitle"
                    pointerEvents="none"
                    children={<MdMailOutline />}
                  />
                  <Input
                    type="email"
                    id="emailAddress"
                    name="emailAddress"
                    placeholder="alex@gmail.com"
                    onChange={formik.handleChange}
                    fontSize={13}
                    value={formik.values.emailAddress}
                    height={"2.5rem"}
                  />
                </InputGroup>
                <FormErrorMessage fontSize={12}>
                  {formik.errors.emailAddress}{" "}
                </FormErrorMessage>
              </FormControl>
            </Flex>

            <Flex
              mb="25px"
              gap={{ lg: "2.2rem", md: "2rem", sm: "1rem", base: "1rem" }}
              flexDirection={{
                lg: "row",
                md: "row",
                sm: "column",
                base: "column",
              }}
            >
              <FormControl
                isInvalid={
                  formik.errors.dob && formik.touched.dob ? true : false
                }
                width={{ lg: "50%", md: "50%", sm: "100%", base: "100%" }}
              >
                <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                  Date of Birth{" "}
                  <Text as="span" color="red">
                    {" "}
                    *{" "}
                  </Text>
                </FormLabel>
                <InputGroup>
                  <Input
                    placeholder="Select Date of Birth"
                    type="date"
                    bg="inputText.500"
                    name="dob"
                    value={formik.values.dob}
                    onChange={formik.handleChange}
                    fontSize={12}
                    height={"2.5rem"}
                  />
                  {/* <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} /> */}
                </InputGroup>
                <FormErrorMessage fontSize={12}>
                  {formik.errors.dob}
                </FormErrorMessage>
              </FormControl>

              <FormControl
                isInvalid={
                  formik.errors.gender && formik.touched.gender ? true : false
                }
                width={{ lg: "50%", md: "50%", sm: "100%", base: "100%" }}
              >
                <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                  Gender{" "}
                  <Text as="span" color="red">
                    {" "}
                    *{" "}
                  </Text>
                </FormLabel>
                <Select
                  ref={courseFormatRef}
                  variant="outline"
                  bg="inputText.500"
                  size="sm"
                  fontSize={12}
                  placeholder="Select gender"
                  value={formik.values.gender}
                  name="gender"
                  height={"2.5rem"}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  color="brand.subtitle"
                >
                  {gender.map((each) => (
                    <option key={each.id} value={each.title}>
                      {" "}
                      {each.title}{" "}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage fontSize={12}>
                  {formik.errors.gender}
                </FormErrorMessage>
              </FormControl>
            </Flex>

            <Flex
              mb={["10px", "20px", "80px", "90px"]}
              justifyContent="flex-end"
              mt={6}
            >
              <HStack>
                {/* <Button colorScheme="white" color='red' size="sm" fontSize={11} borderRadius={10} px={10}>Save & Exit</Button> */}
                <Button
                  py="13px"
                  px="30px"
                  mt="30px"
                  type="submit"
                  fontSize={11}
                  isLoading={formik.isSubmitting}
                  borderRadius={0}
                  colorScheme="red"
                  size="sm"
                >
                  NEXT
                </Button>
              </HStack>
            </Flex>
          </form>
        </Box>
      )}
    </>
  );
};

export default BasicDetailsTr;
